"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const classnames_1 = __importDefault(require("classnames"));
const styles_2 = __importDefault(require("./styles"));
const VARIANTS = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    caption: 'caption',
    large: 'body1',
    small: 'body1',
    body: 'body1'
};
const resolveRootClass = (props) => {
    const { classes, weight, variant, invert, color } = props;
    return classnames_1.default({
        [classes.large]: variant === 'large',
        [classes.small]: variant === 'small',
        [classes.body]: variant === 'body',
        [classes.invert]: invert
    }, classes[weight], classes[color]);
};
exports.Typography = props => {
    const { variant, children, align, className, style, inline, as } = props;
    const resolvedVariant = VARIANTS[variant];
    const rootClass = resolveRootClass(props);
    return (react_1.default.createElement(Typography_1.default, { align: align, className: className, classes: {
            root: rootClass
        }, style: style, variant: resolvedVariant, inline: inline, component: as }, children));
};
exports.Typography.defaultProps = {
    inline: false,
    variant: 'body',
    weight: 'regular'
};
exports.Typography.displayName = 'Typography';
exports.default = styles_1.withStyles(styles_2.default)(exports.Typography);
//# sourceMappingURL=Typography.js.map